import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Functions } from '@hub/common/Functions';
import { eColumnType, eGridArea } from '@hub/generated/enums';
import { GridDto } from '@hub/generated/models';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'main-grid-option-wrapper',
  templateUrl: './main-grid-options-wrapper.component.html'
})
export class MainGridOptionWrapperComponent implements OnInit {
  constructor() {
  }

  private _gridData: any;
  @Input() set GridData(GridData: any) {
    this._gridData = GridData;
    this.gridAreaEnumName = this.getGridAreaEnumName(GridData.GridArea);
  }
  get GridData() {
    return this._gridData;
  }

  @Input() IsEdit: boolean;
  @Input() ShowRedirectHeader: boolean;

  @Output()
  onShowOptions: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() GridDataChange = new EventEmitter<any>();
  gridAreaEnumName = '';
  public isGridVisible: boolean = true;
  public gridOptions: SelectItem[];
  public selectedColumns: string[];

  toggleOptions(val: IOnLazyLoad) {
    this.onShowOptions.emit(val);
  }

  ShowHideColumns(values) {
    this.GridData.Columns = [];
    this.GridData.Columns.push(
      this.GridData.SystemDefaultColumns.find(
        f => f.ColumnType === eColumnType.Checkbox
      )
    );
    for (const value of values.value) {
      this.GridData.Columns.push(
        this.GridData.SystemDefaultColumns.find(f => f.Id === value)
      );
    }

    // hidden columns are always part of grid
    for (const column of this.GridData.SystemDefaultColumns.filter(
      f => f.IsHidden
    )) {
      this.GridData.Columns.push(column);
    }

    this.GridDataChange.emit(this.GridData);
  }

  getGridAreaEnumName(gridArea: eGridArea) {
    switch(gridArea) {
      case eGridArea.TvPackagePackage:
      case eGridArea.TvPackageBooking:
        return 'Packages';
    }
    return Functions.getEnumName(eGridArea, gridArea, true);
  }

  // OnInit
  ngOnInit(): void {
    if (this.IsEdit) {
      this.gridOptions = [];

      for (const column of this.GridData.SystemDefaultColumns) {
        if (column.ColumnType !== eColumnType.Checkbox && !column.IsHidden) {
          this.gridOptions.push({ label: column.Header, value: column.Id });
        }
      }

      this.selectedColumns = [];
      for (const column of this.GridData.Columns) {
        if (column.ColumnType !== eColumnType.Checkbox && !column.IsHidden) {
          let defaultColumn = this.GridData.SystemDefaultColumns.find(
            f => f.Header === column.Header
          );
          this.selectedColumns.push(defaultColumn.Id);
        }
      }
    }
  }
}
